import { useEffect, useState } from "react";
import { useLocation, useParams } from 'react-router-dom';
import { AssistancePlanScreen } from "../../screen/AssistancePlanScreen";
import { useFarmerProfile } from "../../core/context/farmerProfileContext";
import { AssistanceLinkMessageContainer } from "../AssistanceLinkMessageContainer";
import { useChatContext } from "../../core/context/chatContext";
import { useAssistancePlanContext } from "../../core/context/assistancePlanContext";
import { customToast } from "../../components/Toast";
import Send from "../../core/communication";
import { useScope } from "../SelectProjectCompanyContainer";

export const AssistancePlanContainer = ({
  handleOpenAssistance,
  currentOpen,
  onlyForm,
  farmerDetails,
  resetFarmerProfile,
  contextDetails,
  formQuestionMessage,
  setFormQuestionMessage
}) => {
  const { userId } = useParams();
  const { search } = useLocation()
  const { scopeType } = useScope();
  const { hideMainCard, handleChangeBackButton, setPageName } = useFarmerProfile();
  const { handleChangeLinkComponent, pinnedMessages, resetPinnedMessages, setEvidenceId, evidenceId } = useChatContext();
  const { handleChangeAnswer, answers } = useAssistancePlanContext();

  const [currentTab, setCurrentTab] = useState('open');
  const [data, setData] = useState([]);
  const [defaultAnswers, setDefaultAnswers] = useState([]);
  const [isLoadingAssistances, setLoadingAssistances] = useState(false)

  useEffect(() => {
    if (formQuestionMessage) {
      handleChangeAnswer(
        formQuestionMessage?.name,
        formQuestionMessage?.answer,
        pinnedMessages
      );
    }
  }, [pinnedMessages]);

  useEffect(() => {
    if (currentTab) {
      loadTabData()
    }
  }, [currentTab]);

  const loadTabData = async () => {
    try {
      setLoadingAssistances(true)
      const response = await Send.get(
        `/events-sector/categories/${currentTab}/${userId}`,
        `scopeType=${scopeType}`
      );
      console.log("DSDSD", response)
      setData(response);
    } catch (error) {
      console.log("Error -> ", error);
      customToast('Erro ao buscar atendimentos', 'error');
    }
    finally {
      setLoadingAssistances(false)
    }
  };

  const handleChangeTab = (newTab) => {
    if (Array.isArray(newTab)) {
      setCurrentTab(newTab[0]?.type);
    } else {
      setCurrentTab(newTab?.type);
    }
  };

  const handleActive = (value, tab) => {
    setPageName("Atendimento");
    handleOpenAssistance(value, currentTab || 'open');
  };

  const handleSaveDraft = () => {
    try {
      handleActive(null);
    } catch (error) {
      console.log("Error -> ", error);
    }
  };

  const handleCloseTab = () => {
    setFormQuestionMessage(false);
    handleChangeBackButton(true);
    handleChangeLinkComponent();
    resetPinnedMessages();
    setEvidenceId(null);
    !search?.includes("startedForms") && hideMainCard(null, true);
  };

  const handleOpenLinkMessage = (question) => {
    if (!answers[question?.name]) {
      customToast("Você deve preencher a questão", "warning");
      return;
    }

    setFormQuestionMessage(question);
    handleChangeBackButton(false);
    handleChangeLinkComponent(answers[`${question?.name}-messages`]);
    !search?.includes("startedForms") && hideMainCard(null, false);
  };

  return (
    <>
      <div style={{ display: evidenceId ? 'none' : 'block' }}>
        <AssistancePlanScreen
          currentOpen={currentOpen}
          onlyForm={onlyForm}
          handleActive={handleActive}
          handleSaveDraft={handleSaveDraft}
          handleOpenLinkMessage={handleOpenLinkMessage}
          formQuestionMessage={formQuestionMessage}
          pinnedMessagesQuestion={pinnedMessages}
          farmerDetails={farmerDetails}
          resetFarmerProfile={resetFarmerProfile}
          currentTab={currentTab}
          handleChangeTab={handleChangeTab}
          isLoadingAssistances={isLoadingAssistances}
          data={data}
          contextDetails={contextDetails}
          defaultAnswers={defaultAnswers}
          setDefaultAnswers={setDefaultAnswers}
        />
      </div>

      <div style={{ display: evidenceId ? 'block' : 'none' }}>
        <AssistanceLinkMessageContainer
          formQuestionMessage={formQuestionMessage}
          setFormQuestionMessage={setFormQuestionMessage}
          handleCloseTab={handleCloseTab}
          pinnedMessages={answers[`${formQuestionMessage?.name}-messages`] || []}
        />
      </div>
    </>
  );
};
